export default "__VITE_ASSET__B0u17QMO__"